import './Header.scss';

const Header = ({ theme }) => {
  const isToyStory5Theme = theme === 'disney-toy-story-5';

  return (
    <header className="header pt-1 pt-md-3 text-center">
        {isToyStory5Theme ?
        <>
          WELCOME TO THE<br />TOY STORY 5 <span className='text-highlight'>QUIZ</span>
        </> :
        <>
        WELCOME TO THE<br />TEAM LEWIS <span className='text-highlight'>QUIZ</span>
        </>
      }
    </header>
  );
}

export default Header;
